var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 20,
    viewBox: "0 0 34 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 6C14 8.20914 12.2091 10 10 10C7.79086 10 6 8.20914 6 6C6 3.79086 7.79086 2 10 2C12.2091 2 14 3.79086 14 6ZM3 14.5V15.375C3 16.8247 4.34315 18 6 18H14C15.6569 18 17 16.8247 17 15.375V14.5C17 12.567 15.2091 11 13 11H7C4.79086 11 3 12.567 3 14.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 1,
    width: 20,
    height: 20,
    rx: 8,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 5C16.8954 5 16 5.89543 16 7V15.4H17.4468C17.3731 15.6033 17.333 15.8221 17.333 16.05C17.333 17.127 18.2284 18 19.333 18C20.4376 18 21.333 17.127 21.333 16.05C21.333 15.8221 21.2929 15.6033 21.2192 15.4H26.7808C26.7071 15.6033 26.667 15.8221 26.667 16.05C26.667 17.127 27.5624 18 28.667 18C29.7716 18 30.667 17.127 30.667 16.05C30.667 15.8221 30.6269 15.6033 30.5532 15.3999H32.0003V12.7999H28V12.7999H32.0003V10.1999C32.0003 8.76395 30.8064 7.59989 29.3337 7.59989H28V7C28 5.89543 27.1046 5 26 5H18ZM30.6667 10.1999V11.4999H28V8.89995H29.3333C30.0697 8.89995 30.6667 9.48198 30.6667 10.1999ZM19.3306 15.4H19.3358C19.7028 15.4013 19.9998 15.6918 19.9998 16.05C19.9998 16.4089 19.7014 16.7 19.3332 16.7C18.965 16.7 18.6665 16.4089 18.6665 16.05C18.6665 15.6918 18.9636 15.4013 19.3306 15.4ZM28 16.05C28 15.691 28.2985 15.4 28.6667 15.4C29.0349 15.4 29.3333 15.691 29.3333 16.05C29.3333 16.4089 29.0349 16.7 28.6667 16.7C28.2985 16.7 28 16.4089 28 16.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserVehicle);
export default __webpack_public_path__ + "static/media/user-vehicle.7e42d5db640b5bfa56f4df0e0038d21b.svg";
export { ForwardRef as ReactComponent };